import { loadScript } from '@/helpers';
import { CustomerProfile } from '@/models';
import { Achievement, AchievementYear } from '@/models/reward';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';

@Component({
  name: 'CmgRewardsAchievements',
})
export default class CmgRewardsAchievements extends Vue {
  private isLottieLibraryLoaded: boolean = false;

  async mounted() {
    const isLoggedIn = await this.$services.customer.waitForCustomerInitialization();
    if (!isLoggedIn) {
      window.location.replace(`${window.location.origin}${this.$services.config.getRewardsPath()}`);
      return;
    }
    if (!this.$services.loyalty.isLoyaltyEligible(this.$appStore.state.customer.profile)) {
      this.$router.replace({ name: Routes.Rewards });
      return;
    }

    this.setLoadingStatus(true);
    await this.$services.reward.getExtrasAchievements();
    this.setLoadingStatus(false);
    
    if (this.achievements.length > this.previousNumAchievements) {
      await this.loadLottieJsLibrary();

      const comparator = (a: Achievement, b: Achievement) => new Date(b.achievementDate).getTime() - new Date(a.achievementDate).getTime();
      const mostRecentAchievement = this.achievements.sort(comparator)[0];
      this.$services.ui.setModalVisibility('celebrateAchievement', true, { achievement: mostRecentAchievement });

      if (this.customer) {
        this.customer.numAchievements = this.achievements.length;
        this.$services.customer.updateCustomer({ numAchievements: this.achievements.length });
      }
    }
  }

  get customer(): CustomerProfile | null {
    const profile = this.$appStore.state.customer.profile;
    return profile && !profile.isGuest ? profile : null;
  }

  get previousNumAchievements(): number {
    if (this.customer) {
      return this.customer.numAchievements ?? 0;
    }

    return 0;
  }

  get achievements(): Achievement[] {
    return this.$appStore.state.reward.achievements;
  }

  get achievementYears(): AchievementYear[] {
    return this.$appStore.state.reward.achievementYears;
  }

  setLoadingStatus(loading: boolean) {
    this.$services.ui.setAppBlur(loading);
    this.$services.ui.setAppPepperVisibility(loading);
  }

  async loadLottieJsLibrary(): Promise<any> {
    if (!this.isLottieLibraryLoaded) {
      this.isLottieLibraryLoaded = true;
      return await Promise.all([
        loadScript('https://unpkg.com/@lottiefiles/lottie-interactivity@latest/dist/lottie-interactivity.min.js'),
        loadScript('https://unpkg.com/@lottiefiles/lottie-player@1.5.7/dist/lottie-player.js')
      ]);
    }
  }
}
